import { computed, type ComputedRef } from 'vue'

import { usePipe } from '@render/composables/usePipe'
import { tiptapToText } from '@render/lib/tiptapToText'

import { CHECKOUT_TEXT_FIELDS, type CheckoutTexts } from './checkoutOverrides'
import type { CheckoutFields } from './definition'

/**
 * @param fields the checkout's fields
 * @returns each text field that resolves to non-empty plain text in the active
 *   language; reactive on a language switch
 */
export function useCheckoutTexts(fields: () => CheckoutFields): ComputedRef<CheckoutTexts> {
  const pipe = usePipe()
  return computed(() => {
    const texts: CheckoutTexts = {}
    const values = fields()
    for (const field of CHECKOUT_TEXT_FIELDS) {
      const text = tiptapToText(pipe.getTranslation(values[field]?.key))
      if (text) texts[field] = text
    }
    return texts
  })
}
